var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jsp-status-icon",class:[_vm.color, { inline: _vm.inline }]},[_c('Icon',{attrs:{"size":_vm.size,"icon":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }